export function getCurrentHost(): string {
  return window.location.hostname;
}

export function isSuperAdminHost(host: string = getCurrentHost()): boolean {
  return (
    host === 'admin2.squadintouch.com' ||
    host === 'admin2.preprod.squadintouch.com' ||
    host === 'admin2.stage1.squadintouch.com' ||
    host === 'admin2.dev.squadintouch.com' ||
    host === 'admin2.local.squadintouch.com'
  );
}
